/// <reference path="~/Areas/ProductConfiguration/Scripts/ConfigurationV2/ProductConfigurationFilterItem.js" />

var ProductConfigurationFilterModel = function (pageModelHndl) {
    var that = this;

    that.ObjectId = pageModelHndl.ObjectId();
    that.SelectedValues = [];
    that.ArticleReference = pageModelHndl.pProductModel.ArticleReference;
    that.ProductConfigurationV3Enabled = pageModelHndl.ProductConfigurationV3Enabled();

    that.SelectedValues = pageModelHndl.pProductModel.SelectedAttributeAndExtensionValues();
};

